// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__yw7q1","colCheckbox":"styles_colCheckbox__2JFhF"};